import { useCallback, useRef } from 'react';

const useSingleton = () => {
  const running = useRef(false);

  const sigleton = useCallback(async action => {
    if (!running.current) {
      running.current = true;

      try {
        let res = action();

        if (res instanceof Promise) {
          res = await res;
        }

        return res;
      } catch (_err) {
      } finally {
        running.current = false;
      }
    }
  }, []);

  return sigleton;
};

export default useSingleton;
